import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Home from "./Pages/Home";
import { ToastContainer } from "react-toastify";
import Footer from "./Pages/Components/Footer";
import DevNotes from "./Pages/DevNotes";

function App() {
  return (
    <BrowserRouter basename="/moviefinder">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/dev-notes" element={<DevNotes />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
      <Footer />
      <ToastContainer />
    </BrowserRouter>
  );
}

export default App;
